(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/trend/assets/javascripts/trend.js') >= 0) return;  svs.modules.push('/components/lb-ui/trend/assets/javascripts/trend.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useReducer = _React.useReducer;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const isTextOrNumber = svs.components.lbUi.trend.utils.isTextOrNumber;
const Trends = {
  UP: 'up',
  DOWN: 'down',
  NEUTRAL: 'neutral'
};
const Actions = {
  NEW_UNIQUE_ID: 'new_unique_id',
  NEW_VALUE: 'new_value'
};
const TrendChangeTimeout = 7 * 1000;
const trendReducer = (state, action) => {
  switch (action.type) {
    case Actions.NEW_UNIQUE_ID:
    case Actions.NEW_VALUE:
      return _objectSpread(_objectSpread({}, state), action.payload);
    default:
      return state;
  }
};
const Trend = _ref => {
  let uniqueId = _ref.uniqueId,
    postfixSymbol = _ref.postfixSymbol,
    selectorFunction = _ref.selectorFunction,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? undefined : _ref$role,
    ariaLabelPrefix = _ref.ariaLabelPrefix;
  const timer = useRef();
  const value = useSelector(selectorFunction);
  const _useReducer = useReducer(trendReducer, {
      uniqueId,
      value
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(() => {
    const resetLastStatValue = () => {
      dispatch({
        type: Actions.NEW_VALUE,
        payload: {
          value
        }
      });
    };
    timer.current = setTimeout(resetLastStatValue, TrendChangeTimeout);
    return () => {
      clearTimeout(timer.current);
      resetLastStatValue();
    };
  }, [value]);
  useEffect(() => {
    if (state.uniqueId !== uniqueId) {
      dispatch({
        type: Actions.NEW_UNIQUE_ID,
        payload: {
          uniqueId,
          value
        }
      });
      clearTimeout(timer.current);
    }
  }, [uniqueId, value, state.uniqueId]);
  let trend = Trends.NEUTRAL;
  if (uniqueId === state.uniqueId) {
    if (value > state.value) {
      trend = Trends.UP;
    } else if (value < state.value) {
      trend = Trends.DOWN;
    }
  }
  const presentableValue = isTextOrNumber(value) ? "".concat(value).concat(postfixSymbol !== null && postfixSymbol !== void 0 ? postfixSymbol : '') : '-';
  const ariaLabelToUse = ariaLabelPrefix ? "".concat(ariaLabelPrefix, " ").concat(presentableValue) : null;
  return React.createElement("div", {
    "aria-label": ariaLabelToUse,
    className: "stat-trend stat-trend-".concat(trend),
    role: role
  }, presentableValue);
};
setGlobal('svs.components.lbUi.trend.Trend', Trend);

 })(window);